import React, { Fragment } from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRoad } from '@fortawesome/free-solid-svg-icons'
import { faGasPump } from '@fortawesome/free-solid-svg-icons'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'

function VehicleInformation(props) {
    const {
        make,
        model,
        registration_year,
        registration_month,
        price,
        mileage,
        fuel
    } = props;

    return (
        <div
            id="ficha-inf"
            className="vehicleInformationContainer d-none d-md-block"
        >
            <div className="vehicleInformation">
                <div className="container pb-2">
                    <div className="row">
                        <div className="col-xs-12 col-sm-8 col-lg-10">
                            <div className="col-xs-12">
                                <p className="vehicleInformationTitulo">
                                    <b>{make}</b> {model}
                                </p>
                            </div>
                            <div className="col-xs-12">
                                <div>
                                    <span className="mr-3">
                                        <FontAwesomeIcon icon={faCalendar}  className="mr-1"/>
                                        {registration_month} -{" "}
                                        {registration_year}
                                    </span>
                                    <span className="mr-3">
                                        <FontAwesomeIcon icon={faRoad}  className="mr-1"/>
                                        {mileage} Km
                                    </span>
                                    <span className="mr-3">
                                        <FontAwesomeIcon icon={faGasPump}  className="mr-1"/>
                                        {fuel}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-4 col-lg-2">
                            <div className="vehicleInformationPreco">
                                <a
                                    href="tel:917614429"
                                    className="text-white"
                                    style={{ cursor: "pointer" }}
                                >
                                    <div>
                                        {price.toLocaleString()} €
                                        <FontAwesomeIcon icon={faPhone}  className="ml-3"/>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VehicleInformation;
